module.exports = __webpack_public_path__ + "img/08-avatar male.26145012.png";